<template>
  <div ref="rateContainer">
    <div v-if="!rates.length" class="alert alert-warning" style="margin-top: 16px;">We could not find any rates for your
      given destination and package(s). <a @click.prevent="updateActiveStep" href="#">Change shipment details</a>
    </div>

    <div v-if="rates.length">
      <form v-if="rates.length" @submit.prevent="submitForm" :class="[selectable ? 'selectable' : '']">
        <div class="rate-callouts">
          <label class="rate-callout cheapest" v-if="cheapest">
            <div class="rate-callout-label">Cheapest</div>
            <div class="rate-callout-details">
              <!--          <input v-model="selectedRate" v-if="selectable" type="radio" name="id" :value="cheapest.id" :id="cheapest.id"/>-->
              <div class="logo">
                <img :src="cheapest.provider_logo" alt="logo"/>
              </div>
              <div class="rate-price">
                <div>{{ formattedPrice(cheapest.total) }} <span class="currency">{{ cheapest.currency }}</span></div>
                <div class="compare">{{ formattedPrice(cheapest.total * 1.5) }} {{ cheapest.currency }}</div>
              </div>
            </div>
            <div class="rate-description">
              <h4>{{ cheapest.provider }} - {{ cheapest.name }}</h4>
              <span class="rate-terms">{{ cheapest.duration_terms }}</span>
            </div>
          </label>
          <label class="rate-callout fastest" v-if="fastest">
            <div class="rate-callout-label">Fastest</div>
            <div class="rate-callout-details">
              <!--          <input v-model="selectedRate" v-if="selectable" type="radio" name="id" :value="fastest.id" :id="fastest.id"/>-->
              <div class="logo">
                <img :src="fastest.provider_logo" alt="logo"/>
              </div>
              <div class="rate-price">
                <div>{{ formattedPrice(fastest.total) }} <span class="currency">{{ fastest.currency }}</span></div>
                <div class="compare">{{ formattedPrice(fastest.total * 1.5) }} {{ fastest.currency }}</div>
              </div>
            </div>
            <div class="rate-description">
              <h4>{{ fastest.provider }} - {{ fastest.name }}</h4>
              <span class="rate-terms">{{ fastest.duration_terms }}</span>
            </div>
          </label>
        </div>
        <div style="display: flex; align-items: flex-end">
          <h4 style="margin-bottom: 8px;">Choose Shipping Method</h4>
          <div class="sort">
            <select style="border: none" v-model="sortOrder">
              <option value="Time">Sorting by Time</option>
              <option value="Price">Sorting by Price</option>
            </select>
          </div>
        </div>
        <div :class="['rates']">
          <shipping-rate
              v-for="rate in sortedRates"
              :selectable="true"
              :id="rate.id"
              :shipment-uuid="rate.shipment_uuid"
              :key="rate.id"
              :name="rate.name"
              :provider="rate.provider"
              :provider-logo="rate.provider_logo"
              :duration-terms="rate.duration_terms"
              :currency="rate.currency"
              :total="rate.total"
              :selected-rate.sync="selectedRate"
          ></shipping-rate>
        </div>
      </form>
    </div>
  </div>
</template>

<style scoped>
.sort {
  margin-left: auto;
  margin-bottom: 8px;
}

.sort a {
  color: #929292;
}

.sort a.active {
  color: #BF2C33;
}

.logo {
  width: 25px;
  align-self: flex-start;
}

.rate-callout .logo {
  width: 55px;
}

.logo img {
  width: 100%;
  object-fit: contain;
}

h4 {
  margin: 0;
}

.rates {
  margin-bottom: 32px;
}

input[type=radio], input[type=checkbox] {
  margin-right: 24px;
}

.rate .logo {
  margin-right: 24px;
}

.selectable label {
  cursor: pointer;
}

.rate-description {
  margin-right: 32px;
  flex: 1;
}

.rate-terms {
  display: block;
  font-weight: 400;
  font-size: 13.5px;
  line-height: 150%;
}

.rate-price {
  margin-left: auto;
  white-space: nowrap;
  font-weight: 700;
}

.compare {
  text-decoration: line-through;
  font-weight: 400;
  font-size: 13.5px;
  line-height: 150%;
  text-align: right;
  color: #5A5A5A;
}

.currency {
  font-weight: 700;
  font-size: 13.5px;
  line-height: 150%;
  color: #929292;
}

.rate-callout-label {
  font-weight: 700;
  font-size: 18px;
  line-height: 175%;
  color: #929292;
  background: #F2F2F2;
  padding: 3px 13px;
  text-transform: uppercase;
  display: inline-block;
  margin-bottom: 16px;
}

.rate-callouts {
  display: flex;
  flex-direction: column;
  gap: 60px;
  margin-bottom: 60px;
}

@media (min-width: 768px) {
  .rate-callouts {
    flex-direction: row;
  }
}

.rate-callout {
  flex: 1;
  position: relative;
}

.rate-callouts .rate-callout:first-child:before {
  content: '';
  position: absolute;
  width: 1px;
  height: 100%;
  background: #c8c8c8;
  right: -30px;
}

.rate-callout-details {
  display: flex;
  margin-bottom: 16px;
}

</style>

<script>


import {useShipmentStore} from "../stores/shipment";

export default {
  setup(props) {
    const useShipment = useShipmentStore(props.shipmentId);
    const {deleteRates} = useShipment;

    return {
      deleteRates
    }
  },
  components: {},
  props: {
    rates: Array,
    selectable: {
      type: Boolean,
      default: true,
    },
    shipmentId: String,
    active: Number,
  },
  data: () => ({
    publishableKey: window.stripe_pk,
    sortOrder: 'Price',
    selectedRate: null,
    clientSecret: null,
    isLoading: false,
  }),
  methods: {
    updateActiveStep: function () {
      this.$emit('step', 0);
    },
    submit: function () {
      this.$refs.elementRef.submit();
    },
    submitForm(token) {
      this.isLoading = true;
      axios.post(`/shipments/${this.shipmentId}/rates/${this.selectedRate.id}/intent`)
          .then(({data}) => {
            if (data.status) {
              this.clientSecret = data.message;
              this.$emit('update:client-secret', this.clientSecret);
            }
          }).finally(() => this.isLoading = false)
    },
    formattedPrice(cents) {
      const dollars = cents / 100;
      return dollars.toLocaleString("en-US", {style: "currency", currency: "USD"});
    },
  },
  computed: {
    cheapest: function () {
      return this.rates.find(rate => rate.cheapest)
    },
    fastest: function () {
      return this.rates.find(rate => rate.fastest)
    },
    sortedRates: function () {
      return this[`sortBy${this.sortOrder}`];
    },
    sortByPrice: function () {
      return [...this.rates].sort((a, b) => {
        if (a.cheapest) {
          return -1;
        }

        return parseFloat(a.total) - parseFloat(b.total);
      })
    },
    sortByTime: function () {
      return [...this.rates].sort((a, b) => {
        if (a.fastest) {
          return -1;
        }

        return a.estimated_days - b.estimated_days;
      })
    }
  },
  watch: {
    selectedRate: function (newValue, oldValue) {
      this.$emit('update:selected-rate', newValue);
    },
  }
}
</script>
